import { render, staticRenderFns } from "./CandidateEmailVerificationModal.vue?vue&type=template&id=dc22f444&"
import script from "./CandidateEmailVerificationModal.vue?vue&type=script&lang=js&"
export * from "./CandidateEmailVerificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports